import { render, staticRenderFns } from "./Contribute.vue?vue&type=template&id=cc4925ec&scoped=true&"
import script from "./Contribute.vue?vue&type=script&lang=js&"
export * from "./Contribute.vue?vue&type=script&lang=js&"
import style0 from "./Contribute.vue?vue&type=style&index=0&id=cc4925ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4925ec",
  null
  
)

/* custom blocks */
import block0 from "./Contribute.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports